import { Component, OnInit, inject, DestroyRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PolicyService } from '@services/policy.service';
import { FormBuilder } from '@angular/forms';
import { CoreModule } from 'app/modules/core.module';
import { PanelComponent } from '@components/core-template/panel/panel.component';
import { ModalPolicyComponent } from '@components/managements/policies/modal-policy/modal-policy.component';
import { NumberPipe } from 'app/pipes/number.pipe';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-policies',
  standalone: true,
  imports: [ModalPolicyComponent, NumberPipe, PanelComponent, CoreModule,],
  providers: [PolicyService],
  templateUrl: './policies.component.html',
  styleUrls: ['./policies.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PoliciesComponent implements OnInit {


  protected editNew = false
  protected years: any[] = []
  protected Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  })

  public listPolicies: any[] = []
  public listPoliciestemp: any[] = []
  public namePolicy: any
  public editPolicy: any
  public modalOptions = {
    size: 'lg',
    scrollable: true,
    animation: true,
    backdrop: true
  }
  public yearSelected: any
  public closeResult = ""
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  constructor(
    private _policeService: PolicyService,
    private fb: FormBuilder,
    private modalService: NgbModal,
  ) {

  }

  ngOnInit(): void {
    const currentYear = new Date().getFullYear()
    let initialYear = currentYear - 1
    this.yearSelected = currentYear
    this.getPolicies()
    while (initialYear <= currentYear) {
      this.years.push(initialYear)
      initialYear++
    }
  }

  getPolicies() {
    this._policeService.getByYear(this.yearSelected).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => { 
      this.listPolicies = res; 
      this.listPoliciestemp = res
      this.cdr.markForCheck()
    })
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `${reason}`;
    });
  }

  filterPolicies() {
    this.listPolicies = this.listPoliciestemp.filter(g => g.name.toLowerCase().includes(this.namePolicy.toLowerCase()) || g.group == this.namePolicy);
  }

  refreshData(update: any) {
    if (update) this.getPolicies()
    this.editNew = false
    this.editPolicy = null
  }

  openPeriod(){
    Swal.fire({
      text: "¿Desea abrir el periodo " + this.yearSelected + "?",
      icon: 'warning',
      confirmButtonText: 'Si',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      showCancelButton: true,
    }).then(result => {
      if (result.isConfirmed) {
        const fechaSeleccionada = result.value?.fecha;

        this._policeService.openPeriod(this.yearSelected).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(res => {
            if (res) {
              this.Toast.fire({
                icon: 'success',
                title: 'Periodo abierto'
              });
              // this.generateExclution()

            }
          });
      }
    })
  
  }
}
